



















import Vue from 'vue'
import SpiderSelect from '@/components/spider-select.vue'
import { copySpiderSettings } from '@/core/api/spiders'

export default Vue.extend({
  components: {
    SpiderSelect,
  },
  props: {
    show: {
      type: Boolean,
      default: false,
    },
    items: {
      type: Array,
      default: (): [] => [],
    },
  },
  data: () => ({
    dialog: false,
  }),
  watch: {
    show(newVal) {
      this.dialog = newVal
    },
  },
  methods: {
    close() {
      this.$emit('update:show', false)
    },
    onSettingsCloneSelect(spider) {
      this.close()
      copySpiderSettings(
        spider.id,
        this.items.map((x: any) => x.id),
      )
        .then(() => {
          this.$toastSuccess.fire({ title: 'Настройки скопированы' })
          this.$emit('success')
        })
        .catch(() => {
          this.$toastError.fire({ title: 'Произошла ошибка при копировании настроек парсера' })
        })
    },
  },
})
